/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSablonaElektronickychPodpisu extends GContentBase<SeznamAdmSablonaElektronickychPodpisuObj> {
        private seznamObj: SeznamAdmSablonaElektronickychPodpisuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSablonaElektronickychPodpisuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSablonaElektronickychPodpisuNew",
                contentCaption: "jres:33000989", //RC 33000989 : Šablony elektronických podpisů
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_dpo}"
                },
                gridSettings: {
                    columnOrder: "nazev,poznamka,duvod_txt,ktg_duv_podp_txt,priz_znacka,priz_podpis,typ_ltv_txt,priz_ts_txt,priz_kvcrt_txt,typ_viz_podpis_txt,ixs_dpo,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSablonaElektronickychPodpisuObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmSablonaElektronickychPodpisu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmSablonaElektronickychPodpisu",
                newRecord: isNew,
                ixs_dpo: isNew == true ? null : data.ixs_dpo
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"/*, "actOpenDialogVyberovaSkupina*"*/]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"/*, "actOpenDialogVyberovaSkupina*"*/])
        }

        createFilterForm() {
           
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
            
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSablonaElektronickychPodpisu.list({ filters: filterData }).getView().then((data) => {
                this.setPlatnostColumn(data)
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.ixs_sro}#${data.dat_od}#`,
                nazev: `${data.ixs_sfu_txt} - ${data.ixs_fun_txt} - ${Gordic.Templates.Formatters.date(data.dat_od)}`
            }
        }
    }
}